import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { TextField } from 'src/shared/components/Form/TextField';
import { useFormState } from 'react-final-form';
import { Step } from 'src/modules/SaldoView/components/CompanySelectorBar/components/Step';

export const ManualSteps = () => {
  const { t } = useTranslation('form');
  const { values } = useFormState();

  const copyToClipboard = (value: string) => async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Grid2>
      <Step step={1} title="Check the company you are going to recharge:">
        <TextField
          disabled
          name="companyName"
          label={t('field.company')}
          InputProps={{
            style: { width: '100%' }
          }}
        />
      </Step>

      <Step step={2} title="Copy the IBAN and paste it into the destination account:">
        <TextField
          disabled
          name="IBAN"
          label={t('field.iban')}
          InputProps={{
            style: { width: '100%' },
            endAdornment: (
              <IconButton disabled={!values.IBAN} onClick={copyToClipboard(values.IBAN)}>
                <ContentCopyIcon />
              </IconButton>
            )
          }}
        />
      </Step>

      <Step step={3} title="Copy the beneficiary and paste it into its field:">
        <TextField
          disabled
          name="beneficiaryName"
          label={t('field.beneficiary')}
          InputProps={{
            style: { width: '100%' },
            endAdornment: (
              <IconButton onClick={copyToClipboard(values.beneficiaryName)}>
                <ContentCopyIcon />
              </IconButton>
            )
          }}
        />
      </Step>
    </Grid2>
  );
};
